<template>
  <div class="container-fluid p-0">
    <div class="row m-0">
      <div class="col-12 p-0">
        <div class="login-card login-dark">
          <div>
            <div>
              <router-link class="logo" to="/">
                <img class="img-fluid for-light" src="@/assets/images/logo/logo_light.png" alt="loginpage">
                <img class="img-fluid for-dark" src="@/assets/images/logo/logo_light.png" alt="loginpage">
              </router-link>
            </div>
            <div class="login-main">
              <form class="theme-form" @submit.prevent="doLogin">
                <h4>Sign in to account</h4>
                <p>Enter your email & password to login</p>
                <div class="form-group">
                  <label class="col-form-label">Email Address</label>
                  <input v-model="email" class="form-control" type="email" placeholder="Test@gmail.com">
                </div>
                <div class="form-group">
                  <label class="col-form-label">Password</label>
                  <div class="form-input position-relative">
                    <input v-model="password" :type="type" class="form-control" name="login[password]"
                      placeholder="*********">
                    <div class="show-hide"><span class="show" @click="showPassword"> </span></div>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <div class="checkbox p-0">
                    <input id="checkbox1" type="checkbox">
                    <label class="text-muted" for="checkbox1">Remember password</label>
                  </div>
                  <a class="link">
                    <router-link to="/authentication/forget_password">Forgot password?</router-link>
                  </a>
                  <div class="text-end mt-3">
                    <button class="btn btn-primary btn-block w-100" type="submit">Sign in</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { onCompletedLogin } from '@/composables/auth';
import { useRouter } from 'vue-router';

const type = ref<string>('password');
const email = ref<string>('test@admin.com');
const password = ref<string>('test@123456');

const router = useRouter();

function showPassword() {
  type.value = type.value === 'password' ? 'text' : 'password';
}

function doLogin() {
  if (email.value === 'test@admin.com' && password.value === 'test@123456') {
    localStorage.setItem('user', email.value);
    localStorage.setItem('SidebarType', 'compact-wrapper');
    const token = '1234';
    onCompletedLogin(token, router);
  } else {
    toast.error('Oops... Invalid email and password', {
      position: 'top-right',
      icon: 'times',
      autoClose: 2000,
    });
  }
}
</script>